import { request } from './core'
import { buildQueryString } from '../../utils/apiQueryBuilder'
import type { Environment, EnvironmentCreate } from './types'

export const environmentsApi = {
  list: (params?: { search?: string; page?: number; page_size?: number; signal?: AbortSignal }) => {
    const { signal, ...queryParams } = params || {}
    const query = buildQueryString(queryParams)
    return request<{ items: Environment[]; total: number }>(`/environments${query}`, { signal })
  },

  create: (data: EnvironmentCreate) =>
    request<Environment>('/environments', {
      method: 'POST',
      body: JSON.stringify(data),
    }),

  update: (id: string, data: EnvironmentCreate) =>
    request<Environment>(`/environments/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),

  delete: (id: string) =>
    request<void>(`/environments/${id}`, {
      method: 'DELETE',
    }),
}
